import BaseError from '@/error';

/**
 * Error thrown when a a route param is invaild.
 */
export default class InvalidRouteParamError extends BaseError {
  readonly name = "InvalidRouteParamError";


  constructor(param: string, paramValue?: string, reasonInvalid?: string, cause?: Error) {
    super('', cause);
    let msg = `Invalid route param: ${param}`;
    if (paramValue) {
      msg += `(${paramValue})`;
    }

    if (reasonInvalid) {
      msg += `. ${reasonInvalid}`;
    }
    msg += '.';
    this.message = msg;
  }
}
